/** @jsx jsx */
import { jsx, Box } from 'theme-ui'
import { FiX } from 'react-icons/fi'

export const LINE_FRIEND_URL =
  'https://engibiz-line.ukmeta.workers.dev/r/engibiz-home-qr'

type ImageModalProps = {
  isOpen: boolean
  onClose: () => void
  src: string
  alt?: string
}

const ImageModal = ({ isOpen, onClose, src, alt }: ImageModalProps) => {
  if (!isOpen) return null

  return (
    <Box
      role="dialog"
      aria-modal="true"
      sx={{ position: 'fixed', inset: 0, zIndex: 1000 }}
    >
      <Box
        onClick={onClose}
        sx={{
          position: 'absolute',
          inset: 0,
          backgroundColor: 'rgba(2,6,23,0.45)',
        }}
      />
      <Box
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: ['calc(100vw - 30px)', '400px'],
          maxWidth: ['calc(100vw - 30px)', '400px'],
          borderRadius: 14,
          overflow: 'hidden',
          boxShadow: '0 30px 80px rgba(2,6,23,0.25)',
        }}
      >
        <Box sx={{ position: 'relative' }}>
          <a
            href={LINE_FRIEND_URL}
            sx={{ display: 'block', lineHeight: 0 }}
          >
            <img
              src={src}
              alt={alt ?? ''}
              sx={{ display: 'block', width: '100%', height: 'auto' }}
            />
          </a>
          <button
            type="button"
            aria-label="閉じる"
            onClick={onClose}
            sx={{
              position: 'absolute',
              top: 2,
              right: 2,
              width: 40,
              height: 40,
              borderRadius: '999px',
              backgroundColor: 'rgba(0,0,0,0.5)',
              color: '#fff',
              border: 'none',
              fontWeight: 900,
              display: 'inline-flex',
              alignItems: 'center',
              justifyContent: 'center',
              lineHeight: 1,
              cursor: 'pointer',
              ':hover': { backgroundColor: 'rgba(0,0,0,0.65)' },
            }}
          >
            <FiX size={22} />
          </button>
        </Box>
      </Box>
    </Box>
  )
}

export default ImageModal
